import { FC, SVGProps, useEffect, useState } from "react";
import { IconName } from "./IconNames";
import React from "react";
import { log } from "utils/LogUtil";
import { LogLevel } from "utils/LogUtil";

export interface Props extends React.SVGProps<SVGSVGElement> {
  name: IconName | string; // IconName enum 또는 string 허용 (기존 코드 호환성을 위해)
  className?: string;
  size?: number;
  color?: string;
}

const Icon = ({ name, className, size, color, ...svgProps }: Props): JSX.Element => {
  const [SvgIcon, setSvgIcon] = useState<FC<SVGProps<SVGSVGElement>>>();

  useEffect(() => {
    let isComponentMounted = true;

    const importSvgDynamically = async () => {
      try {
        const importedModule = await import(
          `!!@svgr/webpack?-svgo,+titleProp,+ref!./svgs/${name}.svg`
        );
        if (isComponentMounted) setSvgIcon(importedModule.default);
      } catch (error) {
        log(LogLevel.ERROR, `Icon name '${name}' is not found`);
      }
    };
    importSvgDynamically();

    return () => {
      isComponentMounted = false;
    };
  }, [name]);

  return SvgIcon ? (
    <SvgIcon
      width={size}
      height={size}
      fill={color}
      {...svgProps}
      style={{ verticalAlign: "top", minWidth: size }}
      className={className}
    />
  ) : (
    <></>
  );
};

export default Icon;
